"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRegistrationInputs = exports.formatLoginInputs = exports.formatInputs = exports.formatRecurrentOptions = exports.formatOptions = exports.validatePassword = exports.validateEmail = void 0;
var validateEmail = function (email) {
    // tslint:disable-next-line:max-line-length
    var regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regExp.test(email.toLowerCase());
};
exports.validateEmail = validateEmail;
var validatePassword = function (password) {
    var regExp = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    return regExp.test(password);
};
exports.validatePassword = validatePassword;
var formatOptions = function (inputModel, key, value) {
    return inputModel.map(function (item) {
        return {
            title: item[value],
            value: item[key]
        };
    });
};
exports.formatOptions = formatOptions;
var formatRecurrentOptions = function (inputModel, propNames) {
    return inputModel.map(function (currentCountry) {
        return {
            name: currentCountry.Key,
            value: (0, exports.formatOptions)(currentCountry.Value, propNames.key, propNames.value)
        };
    });
};
exports.formatRecurrentOptions = formatRecurrentOptions;
var formatInputs = function (inputFields, inputModel, requiredFields) {
    return Object.keys(inputFields).map(function (value) {
        return {
            errorMessage: inputModel[value + "ValidationMessage"] ||
                inputModel[value + "ValidationMessageEmpty"] || "",
            formatErrorMessage: inputModel[value + "ValidationMessageIncorrectFormat"],
            hint: inputModel[value + "Info"] || "",
            name: inputFields[value],
            label: inputModel[value + "Label"] || "",
            placeholder: inputModel[value + "Placeholder"] || "",
            propName: value,
            required: requiredFields.indexOf(value) !== -1
        };
    });
};
exports.formatInputs = formatInputs;
var formatLoginInputs = function (inputFields, inputModel, requiredFields) {
    return Object.keys(inputFields).map(function (value) {
        return {
            errorMessage: inputModel[value + "ValidationFieldIsEmpty"] ||
                inputModel[value + "ValidationInvalidEmailOrUsername"] ||
                inputModel[value + "ValidationFieldPasswordDoesNotMatch"] || "",
            formatErrorMessage: inputModel[value + "ValidationMessageIncorrectFormat"],
            hint: inputModel[value + "Info"] || "",
            name: inputFields[value],
            label: inputModel[value + "Label"] || "",
            placeholder: inputModel[value + "Placeholder"] || "",
            propName: value,
            required: requiredFields.indexOf(value) !== -1
        };
    });
};
exports.formatLoginInputs = formatLoginInputs;
var formatRegistrationInputs = function (inputFields, inputModel, requiredFields) {
    return Object.keys(inputFields).map(function (value) {
        if (inputModel[value] === null) {
            inputModel[value] = {};
        }
        return {
            errorMessage: inputModel[value]["ValidationMessage"] || "",
            formatErrorMessage: inputModel[value]["ValidationMessageIncorrectFormat"] ||
                inputModel[value]["ValMesDoesNotMatchRequirements"] ||
                inputModel[value]["DoesNotEqual"] ||
                inputModel[value]["ValidationMessage"],
            hint: inputModel[value]["Tooltip"] || "",
            name: inputFields[value],
            value: inputModel[value]["Value"] || "",
            label: inputModel[value]["NameLabel"] || "",
            placeholder: inputModel[value]["Placeholder"] || "",
            id: inputModel[value]["FormFieldId"] || "",
            propName: value,
            required: requiredFields.indexOf(value) !== -1
        };
    });
};
exports.formatRegistrationInputs = formatRegistrationInputs;
